// extracted by mini-css-extract-plugin
module.exports = {"presentation":"Presentation_presentation__1kR40"};